module.exports = __webpack_public_path__ + "media/images/clock-e0f3f7c0a66cb8d4ef11276f0ed4d745.svg";